module.exports = __webpack_public_path__ + "img/12th_life-skills.67a72be4.webp";